export default function between(x, min, max) {
    return x >= min && x <= max;
}
